import * as _ from 'lodash'

export const downloadFile = (filename: string, blob) => {
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')

	document.body.appendChild(a)
	a.style.display = 'none'

	if (canAnchorDownload) {
		a.href = url
		a.download = filename
		a.click()
	} else {
		navigator.msSaveOrOpenBlob(blob, filename)
	}

	_.defer(() => {
		URL.revokeObjectURL(url)
		document.body.removeChild(a)
	})
}

const canAnchorDownload = (
	document.createElement('a').download !== undefined ||
	!navigator.msSaveOrOpenBlob
)

export interface FileNameOptions {
	name?: string,
	includePageName?: boolean,
	includeRefId?: boolean,
	includeStudySet?: boolean,
	includeTime?: boolean
}

export const getFileName = (options: FileNameOptions): string => {
	const nameParts = []

	if (options.name) {
		nameParts.push(options.name)
	}

	// if (options.includePageName) {
	// 	const pageName = safely(app.router.current.route.title)
	// 	if (pageName) {
	// 		nameParts.push(formatString(pageName))
	// 	}
	// }
	//
	// if (options.includeStudySet) {
	// 	const currentStudySet = app.user.currentStudySet
	// 	const studySet = currentStudySet.Name || currentStudySet.Gestalt
	//
	// 	if (studySet) {
	// 		nameParts.push(formatString(studySet))
	// 	}
	// }
	//
	// if (options.includeRefId) {
	// 	const refId = safely(app.admin.page.study.Id)
	// 	if (refId) {
	// 		nameParts.push(refId)
	// 	}
	// }

	if (options.includeTime) {
		const d = new Date()
		nameParts.push(d.getFullYear() + '-' + ((d.getMonth() + 1) + '').padStart(2, '0') + '-' + (d.getDate() + '').padStart(2, '0'))
	}
	return nameParts.join('_')
}

const formatString = (str: string): string => (
	str.split(' ').join('').substring(0, 12).trim()
)
